import "./DifficultyDropdown.css"

export default function DifficultyDropdown({difficulty_checkboxes, set_difficulty_checkboxes}){

    const checkboxClickHandler = (difficulty) => {
        if (!difficulty_checkboxes.includes(difficulty)) set_difficulty_checkboxes([...difficulty_checkboxes, difficulty])
        else set_difficulty_checkboxes(difficulty_checkboxes.filter(diff => diff != difficulty))
    }

    return (
        <div className="options-container">
            <ul className="options-list">
                <li className="pink"
                    onClick={() => checkboxClickHandler("Trivial")}
                >
                    Trivial
                    <label className="difficulty-checkbox">
                        <input type="checkbox" className="checkbox" 
                            checked={difficulty_checkboxes.includes("Trivial")}/>
                    </label>
                </li>
                <li className="green" 
                    onClick={() => checkboxClickHandler("Easy")}
                >
                    Easy
                    <label className="difficulty-checkbox">
                        <input type="checkbox" className="checkbox" 
                            checked={difficulty_checkboxes.includes("Easy")}/>
                    </label>
                </li>
                <li className="yellow"
                    onClick={() => checkboxClickHandler("Medium")}
                >
                    Medium
                    <label className="difficulty-checkbox">
                        <input type="checkbox" className="checkbox" 
                            checked={difficulty_checkboxes.includes("Medium")}/>
                    </label>
                </li>
                <li className="red"
                    onClick={() => checkboxClickHandler("Hard")}
                >
                    Hard
                    <label className="difficulty-checkbox">
                        <input type="checkbox" className="checkbox" 
                            checked={difficulty_checkboxes.includes("Hard")}/>
                    </label>
                </li>
            </ul>
        </div>
    );
}
